import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useEditChecklistMutation } from "app/api/checklists";
import { Categories, Category } from "models/Checklist";
import React, { useState } from "react";
import { toast } from "react-toastify";

type EditCategoriesModalProps = {
  checklistId: string;
  categories: Category[];
  onClose: () => void;
};

const EditCategoriesModal: React.FC<EditCategoriesModalProps> = (props) => {
  const { checklistId, categories: initialCategories, onClose } = props;
  const [categories, setCategories] = useState([...initialCategories]);
  const [editChecklist, { isLoading }] = useEditChecklistMutation();

  const handleSave = async () => {
    const requestBody = { id: checklistId, categories };

    editChecklist(requestBody)
      .unwrap()
      .then(() => {
        toast.success("Kategorierna uppdaterades!", {
          autoClose: 3000,
          hideProgressBar: true,
        });
      })
      .catch(() => {
        toast.error("Något gick fel när kategorierna skulle redigeras.", {
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
    onClose();
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>Redigera kategorier</DialogTitle>
      <DialogContent dividers sx={{ display: "grid" }}>
        {Object.entries(Categories).map(([key, value]) => (
          <FormControlLabel
            key={key}
            label={value}
            control={
              <Checkbox
                checked={categories.includes(key as Category)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setCategories((prev) => [...prev, key as Category]);
                  } else {
                    setCategories((prev) => prev.filter((cat) => cat !== key));
                  }
                }}
              />
            }
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={isLoading}>
          Avbryt
        </Button>
        <Button variant="contained" onClick={handleSave} loading={isLoading}>
          Spara
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCategoriesModal;
